import { call, put, takeLatest } from 'redux-saga/effects';

import * as eventsActions from './eventsActions.js';
import { updateEventsApiCall } from './eventsAPI.js';

function* updateEventsSaga({ payload }) {
  try {
    const { data } = yield call(updateEventsApiCall, payload);
    yield put(eventsActions.eventsUpdateStore(data));
  } catch (error) {
    yield put(eventsActions.eventsUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* eventsWatcher() {
  yield takeLatest(eventsActions.eventsUpdateRequest.type, updateEventsSaga);
}
